import { render } from "./SideModal.vue?vue&type=template&id=51688596&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"

import "./SideModal.vue?vue&type=style&index=0&id=51688596&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51688596"]])

export default __exports__